<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { showFailToast } from "vant";

import { api, apiMessage } from "../api";

const router = useRouter();
const route = useRoute();
const entryToken = ref(typeof route.query.entry === "string" ? route.query.entry : "");
const hasEntryLink = computed(() => Boolean(entryToken.value));
const name = ref("");
const accepted = ref(false);
const loading = ref(false);

async function join() {
  if (!hasEntryLink.value) {
    showFailToast("请使用邀请方提供的专属链接或二维码");
    return;
  }
  if (!name.value.trim()) {
    showFailToast("请填写姓名");
    return;
  }
  if (!accepted.value) {
    showFailToast("请确认已阅读使用说明");
    return;
  }
  loading.value = true;
  try {
    const { data } = await api.post("/public/invites/join", {
      entry_token: entryToken.value,
      name: name.value.trim(),
    });
    await router.push(`/assessment/${data.session_token}`);
  } catch (error) {
    showFailToast(apiMessage(error));
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <main class="join-page">
    <section class="hero-panel">
      <div class="product-mark">职业发展测评</div>
      <h1>更清楚地看见<br />你的工作方式</h1>
      <p>从价值、风格、动机和才干出发，建立一份可验证的职业发展画像。</p>
      <div class="facts">
        <span>七个模块</span>
        <span>约 45 分钟</span>
        <span>支持断点续答</span>
      </div>
    </section>

    <section class="join-card">
      <div class="section-kicker">开始测评</div>
      <h2>{{ hasEntryLink ? "填写姓名开始测评" : "请使用专属答题入口" }}</h2>
      <div v-if="hasEntryLink" class="entry-ready">
        邀请信息与候选人编号已由专属链接自动带入，无需手动填写。
      </div>
      <div v-else class="entry-invalid">
        当前页面没有有效的专属入口信息。请扫描邀请方提供的二维码，或重新打开对方发送的完整链接。
      </div>
      <van-field
        v-if="hasEntryLink"
        v-model="name"
        label="姓名"
        placeholder="请输入本人姓名"
        maxlength="80"
        clearable
      />
      <div v-if="hasEntryLink" class="notice">
        <strong>使用说明</strong>
        <p>请根据真实、通常的状态作答。没有标准答案，过度思考反而可能降低结果的参考价值。</p>
      </div>
      <van-checkbox v-if="hasEntryLink" v-model="accepted" shape="square">
        我已了解：结果仅供职业发展参考，不构成心理诊断或招聘淘汰依据。
      </van-checkbox>
      <van-button v-if="hasEntryLink" type="primary" block round :loading="loading" @click="join">
        进入测评
      </van-button>
    </section>
  </main>
</template>
